import { render, staticRenderFns } from "./Panelsol.vue?vue&type=template&id=27953b35&scoped=true&"
import script from "./Panelsol.vue?vue&type=script&lang=js&"
export * from "./Panelsol.vue?vue&type=script&lang=js&"
import style0 from "./Panelsol.vue?vue&type=style&index=0&id=27953b35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27953b35",
  null
  
)

export default component.exports